import { DEFAULT_SSO_AUTH_URL, LOGOUT_ACTION } from './constants.js';
const buildRedirectUrl = (url, params) => {
    return `${url}${url.indexOf('?') > -1 ? '&' : '?'}${params.join('&')}`;
};
const redirectTo = (url) => {
    return window.location.assign(url);
};
export const getAuthUrl = () => {
    const [, region = ''] = window.location.host.split('.');
    return DEFAULT_SSO_AUTH_URL[`${region.toUpperCase()}`] || `/auth/`;
};
export const getLogoutUrl = (onsuccessUrl = '') => {
    const params = [];
    const logoutUrl = getAuthUrl();
    if (logoutUrl.indexOf('onsuccess') === -1) {
        params.push(`onsuccess=${encodeURIComponent(onsuccessUrl || window.location.href)}`);
    }
    if (logoutUrl.indexOf('from') === -1 && document.referrer) {
        params.push(`from=${encodeURIComponent(document.referrer)}`);
    }
    return buildRedirectUrl(`${logoutUrl}${LOGOUT_ACTION}`, params);
};
export const redirectToLoginPage = (onsuccessUrl = '') => {
    const params = [];
    const loginUrl = getAuthUrl();
    if (loginUrl.indexOf('onsuccess') === -1) {
        params.push(`onsuccess=${encodeURIComponent(onsuccessUrl || window.location.href)}`);
    }
    redirectTo(buildRedirectUrl(loginUrl, params));
};
export const redirectToLogoutPage = (onsuccessUrl = '') => {
    redirectTo(getLogoutUrl(onsuccessUrl));
};
export * from './constants.js';
export default {
    DEFAULT_SSO_AUTH_URL,
    redirectToLoginPage,
    redirectToLogoutPage,
};
